import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

export type TagSeverity = 'success' | 'info' | 'warn' | 'danger' | 'secondary' | 'contrast' | 'primary' | null | undefined;

const TAG_COLOR: Record<string, string> = {
	success: 'success',
	info: 'info',
	warn: 'warning',
	danger: 'danger',
	secondary: 'secondary',
	contrast: 'dark',
	primary: 'primary',
};

/** Etichetta colorata (badge bootstrap con i colori "light" del tema), al posto di p-tag/p-badge di primeng. */
@Component({
	selector: 'app-tag',
	standalone: true,
	changeDetection: ChangeDetectionStrategy.OnPush,
	template: `<span class="badge" [class]="'bg-light-' + color" [class.rounded-pill]="rounded">{{ value }}<ng-content /></span>`,
})
export class TagComponent {
	@Input() value: string | number | null | undefined;
	@Input() severity: TagSeverity | string = 'secondary';
	@Input() rounded = false;

	get color(): string {
		return TAG_COLOR[this.severity ?? 'secondary'] ?? 'secondary';
	}
}
